'use client';

import { ThemeProvider } from '@/context/ThemeContext';
import Footer from '@/components/Footer';
import Header from '@/components/Header';
import ThemeTransition from '@/components/ThemeTransition';

export default function ClientLayout({ children }: { children: React.ReactNode }) {
  return (
    <ThemeProvider>
      <ThemeTransition />
      <Header />
      <main className="flex-grow pt-16">
        {children}
      </main>
      <Footer />
    </ThemeProvider>
  );
} 